import model from './assets/mazhuda.webp';
import './App.css';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import PinterestIcon from '@mui/icons-material/Pinterest';
import IconButton from '@mui/material/IconButton';


const PageNotFound = () => {
  return(
    <div>
        <div className="App-header">
   <h3>Hi there..</h3>
   <span>My name is mazhuda</span>
      </div>
      
      <div className="campaign">
   <h3>////// Business Contact</h3>
   <b>Endorse, ads, promote, content, etc.</b>
   
      <div className="kontak">
  <IconButton href="https://wa.me/6285714177199?text=Hallo%20Mazhuda%0Afrom%20https://mazhuda.web.app"><WhatsAppIcon /></IconButton>
  <IconButton href="https://instagram.com/mazhvda"><InstagramIcon /></IconButton>
<IconButton href="https://facebook.com/mazhvda"><FacebookIcon /></IconButton>
<IconButton href="https://x.com/mazhvda"><TwitterIcon /></IconButton>
<IconButton href="https://id.pinterest.com/mazhvda"><PinterestIcon /></IconButton>
</div>
    </div>
    
      <div className="modelWrap">
       <h1>×××××</h1>
        <h1>Mazhvda</h1>
       <h>tiktoktiktoktiktok</h>
        <h1>////////////////////</h1>

        <div><img src={model} alt="model" className="model" /></div>
      </div>
    </div>
  )
}

export default PageNotFound